import React from "react";
import Hero from "@/components/Hero";
import WhyUs from "@/components/WhyUs";
import Services from "@/components/Services";
import InterventionZone from "@/components/InterventionZone";
import BeforeAfter from "@/components/BeforeAfter";
import Credibility from "@/components/Credibility";
import QuoteForm from "@/components/QuoteForm";
import Seo from "@/components/Seo";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Seo
        title="SIGNA CLEAN | Nettoyage technique et sécurité lumineuse en Martinique"
        description="SIGNA CLEAN accompagne les collectivités, entreprises, syndics et particuliers en Martinique avec des prestations de nettoyage technique, nettoyage de gouttières, lessivage de sols, pose de plots solaires LED et solutions photoluminescentes."
        keywords="nettoyage technique Martinique, nettoyage gouttières Martinique, lessivage sols Martinique, plots solaires LED Martinique, nez de marches photoluminescents Martinique, photoluminescence Martinique, sécurité signalisation Martinique, SIGNA CLEAN Fort-de-France"
        canonical="https://signaclean.fr/"
      />
      <Hero />
      <WhyUs />
      <Services />
      <InterventionZone />
      <BeforeAfter />
      <Credibility />
      <QuoteForm />
    </main>
  );
}
